import { render } from "./MBadgeModal.vue?vue&type=template&id=dc2cc0d0"
import script from "./MBadgeModal.vue?vue&type=script&lang=ts"
export * from "./MBadgeModal.vue?vue&type=script&lang=ts"
script.render = render

export default script